export const BRAND = {
  name: "7 Electric Advice",
  owner: "Manny Diaz",
  tagline: "Precision Power. Proven Expertise.",
  website: "7electricadvice.com",
  phone: "(310) 904-5585",
  phoneHref: "tel:+13109045585",
  email: "sevenelectric@gmail.com",
  address: "110 North Doheny Drive, Los Angeles, CA 90211",
  license: "886996",
  logo: "https://irp.cdn-website.com/e1e15734/dms3rep/multi/opt/seven-electric-logo%28600%29-1920w.png",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHw0fHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBwYW5lbHxlbnwwfHx8fDE3ODY0MjA4MjZ8MA&ixlib=rb-4.1.0&q=85",
  industrial: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxlbGVjdHJpY2lhbiUyMHdvcmtpbmclMjBwYW5lbHxlbnwwfHx8fDE3ODY0MjA4MjZ8MA&ixlib=rb-4.1.0&q=85",
  residential: "https://images.unsplash.com/photo-1628744448840-55bdb2497bd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBob21lJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg2NDIwODI2fDA&ixlib=rb-4.1.0&q=85",
  manny: "https://customer-assets-wrfwihn1.emergentagent.net/job_electric-advice/artifacts/m7kg79s9_Manny%20White_Linkedin%20Profile.webp",
};

export const TIERS = [
  {
    id: "Homeowner",
    label: "01 / Residential",
    name: "Homeowner",
    price: 150,
    tagline: "For everyday people & remodels",
    image: IMAGES.residential,
    desc: "Straight answers before you spend a dollar. Panel upgrades, EV chargers, smart home, lighting, safety and code questions — reviewed and planned right the first time.",
    features: [
      "60-minute expert consultation",
      "Panel & load assessment",
      "EV charger & solar readiness review",
      "Go Green Financing guidance",
      "Generac Certified backup power advice",
      "Written scope & ballpark estimate",
    ],
  },
  {
    id: "Commercial",
    label: "02 / Commercial",
    name: "Commercial",
    price: 200,
    tagline: "For offices, retail & restaurants",
    image: IMAGES.hero,
    desc: "Guidance that keeps the business inspection-ready and downtime-free. Tenant improvement strategy, equipment load planning, lighting design and contingency planning for spaces that can't afford surprises.",
    features: [
      "90-minute site & systems review",
      "Code compliance & permitting strategy",
      "Equipment & sub-panel load planning",
      "Downtime & phasing roadmap",
      "Generac Certified backup power advice",
      "Priority follow-up support",
    ],
    featured: true,
  },
  {
    id: "Industrial",
    label: "03 / Industrial",
    name: "Industrial",
    price: 250,
    tagline: "For facilities & heavy loads",
    image: IMAGES.industrial,
    desc: "Heavy-duty advisory for warehouses and production facilities — three-phase, distribution, controls and reliability, guided by 40+ years in the field.",
    features: [
      "On-site or virtual facility audit",
      "Three-phase & distribution planning",
      "Preventative maintenance strategy",
      "Utility & SCE coordination",
      "Generac Certified backup power advice",
      "Ongoing advisory retainer available",
    ],
  },
];

export const CHAPTERS = [
  { no: "01", title: "Diagnose", body: "We start with the truth about your system — no guesswork, no upsells. Four decades of pattern recognition, applied to your exact situation." },
  { no: "02", title: "Plan", body: "A clear, code-compliant roadmap with honest numbers. You'll know the scope, the sequence, and where financing can lighten the load." },
  { no: "03", title: "Decide", body: "You leave with an independent plan and honest numbers you fully own — ready to act on with confidence and hand to the contractor of your choice." },
];

export const SERVICES = [
  { title: "Panel & Service Advice", body: "Know if and when you need an upgrade — load calcs, sizing and utility coordination explained clearly." },
  { title: "EV Charging & Solar", body: "Independent readiness assessments and an install strategy you can hand to any contractor." },
  { title: "Lighting & Smart Systems", body: "Lutron Pro certified guidance on getting the look you want without overpaying." },
  { title: "Troubleshooting & Second Opinions", body: "Not sure a quote is right? Manny diagnoses the real issue and tells you straight." },
  { title: "Tenant & Fit-Out Planning", body: "Advice on layout, loads and sub-panels so commercial build-outs go smoothly." },
  { title: "Three-Phase & Distribution", body: "Planning and reliability guidance for heavy industrial power — before you spend." },
];

export const TESTIMONIALS = [
  { name: "Melinda Soriano", text: "Manny walked us through every option and gave us honest numbers before we committed to anything. His guidance saved us from costly mistakes and made the whole project finally make sense." },
  { name: "Khaled Al-Arashi", text: "Manny's advice was invaluable for our restaurant openings. He caught problems on paper before they became expensive, and was always a call away whenever we needed direction." },
  { name: "Linda Mays", text: "Consulting with Manny gave us total clarity. Trustworthy, professional and refreshingly straight — he told us exactly what we needed, and what we didn't." },
  { name: "Michael Mcnamara", text: "Manny asked all the right questions and helped us understand our options with zero pressure. His recommendations were smarter and saved us money. Highly recommend his consulting." },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Pricing", to: "/pricing" },
];
